// Фиксит прокрутку до якоря для iOS Safari
const plugin: NuxtPlugin = ({ route }) => {
  const { hash } = route
  if (hash) setTimeout(() => { window.location.href = hash }, 1)
}
export default plugin
